export enum LoyaltyProgramStatus {
    // todo
}